import "../../../index60.css";
import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { MoreFillIcon as a } from "@ifrc-go/icons";
import { _ as l } from "../../../cs-piwRuCFZ.js";
import "../../../type-BFTbooL7.js";
import m from "../../DropdownMenu/index.js";
const p = "_table-actions_171sq_1", _ = "_more-icon_171sq_6", r = {
  tableActions: p,
  moreIcon: _
};
function h(s) {
  const {
    className: e,
    children: n,
    extraActions: o,
    persistent: c
  } = s;
  return /* @__PURE__ */ i("div", { className: l(r.tableActions, e), children: [
    n,
    o && /* @__PURE__ */ t(
      m,
      {
        withoutDropdownIcon: !0,
        variant: "tertiary",
        label: /* @__PURE__ */ t(a, { className: r.moreIcon }),
        persistent: c,
        children: o
      }
    )
  ] });
}
export {
  h as default
};
